import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
// Component
import { StatusTag } from '../../../components/Common/StatusTag'
import DashboardLayout from '../../../layouts/DashboardLayout/DashboardLayout'
import AppPageHeader from '../../../components/AppPageHeader'
import CanvasDoc from './CanvasDoc'
// Styled Component
// Ant Design
import { DeleteOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { Button, Dropdown, Menu, message, Modal } from 'antd'
// Other
import { inject, observer } from 'mobx-react'
import AccessControlAction from '../../../components/AccessControlAction'
import {
  ArrowLeftBroken,
  MenuDotsOutlineIcon,
} from '../../../components/AppIcon'
import { systemName } from '../../../config'
import { ACL_ACTION_TYPE, TYPE_STATUS } from '../../../constants'

const { confirm } = Modal

const InternalDocumentSignDocDetailPage = props => {
  const {
    loadingAnimationStore,
    history,
    fileStore,
    match,
    electronicDocumentStore,
    signedDocumentStore,
    notificationStore,
  } = props
  const { documentId } = match.params

  const { selectedElectronicDocument } = electronicDocumentStore

  useEffect(() => {
    ;(async () => {
      loadingAnimationStore.showSpinner(true)
      try {
        const {
          data,
        } = await electronicDocumentStore.getElectronicDocumentById(documentId)
        await fileStore.downloadAttachment(
          data.action_history.find(el => el.action === data.status).file_id
        )
      } catch (err) {
        history.push('/internal-document/sign-document')
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()
    return () => {
      electronicDocumentStore.clearSelectedElectronicDocument()
      electronicDocumentStore.clearCommentElectronicDocumentList()
      signedDocumentStore.clearDataPopupSign()
      signedDocumentStore.clearSignatureList()
      fileStore.clearDocumentAttachment()
      notificationStore.clearNotificationType()
    }
  }, [documentId])

  const handleDeleteElectronicDocument = async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      await electronicDocumentStore.deleteElectronicDocument(documentId)
      history.push('/internal-document/sign-document')
      message.success('Xóa trình ký thành công!')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }
  const showConfirm = () => {
    confirm({
      title: 'Bạn có muốn xóa trình ký này không?',
      icon: <QuestionCircleOutlined style={{ color: 'red' }} />,
      okText: 'Đồng ý',
      cancelText: 'Không',
      okType: 'danger',
      onOk() {
        handleDeleteElectronicDocument()
      },
    })
  }

  const menuHandleDocument = (
    <Menu>
      <Menu.Item danger onClick={showConfirm} icon={<DeleteOutlined />}>
        Xóa trình ký
      </Menu.Item>
    </Menu>
  )
  return (
    <DashboardLayout>
      <Helmet>
        <title>Chi tiết trình ký | Quản lý VB {systemName}</title>
      </Helmet>
      <AppPageHeader
        title={
          <>
            <span>{selectedElectronicDocument.title}</span>
            <StatusTag
              type={TYPE_STATUS.ELECTRONIC_DOCUMENT}
              status={selectedElectronicDocument.status}
            />
          </>
        }
        showBackButton
        addon={
          <AccessControlAction
            aclActionType={ACL_ACTION_TYPE.delete__PHAT_HANH_VB}>
            <Dropdown overlay={menuHandleDocument} trigger={['click']}>
              <Button
                style={{ width: 40, height: 40, flexShrink: 0 }}
                icon={
                  <MenuDotsOutlineIcon
                    style={{
                      width: 20,
                      height: 20,
                      transform: 'rotate(90deg)',
                    }}
                  />
                }
                shape="circle"
                type="text"
                className="custom-ant-button icon-btn"
              />
            </Dropdown>
          </AccessControlAction>
        }
      />

      <CanvasDoc />
    </DashboardLayout>
  )
}

InternalDocumentSignDocDetailPage.propTypes = {}
export default inject(
  'selectUserStore',
  'departmentStore',
  'loadingAnimationStore',
  'fileStore',
  'internalDocumentStore',
  'signedDocumentStore',
  'electronicDocumentStore',
  'notificationStore'
)(observer(InternalDocumentSignDocDetailPage))
